module.exports = __webpack_public_path__ + "bg.no2.0adbd64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bg.no2.jpg
// module id = AB5h
// module chunks = 0